import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import toast from "react-hot-toast";
import AxiosInstance from "../../utils/axiosInstance";
import loaderImg from "../../assets/loader.svg";

export default function UploadProjectRequestModal({
  open,
  handleClose,
  requestApproved,
}) {
  const Keysoptions = [
    { value: "city", label: "City" },
    { value: "county", label: "County" },
    // { value: "design_build", label: "Design Build" },
    { value: "design_build_wah", label: "Design Build WAH" },
    { value: "design_build_mrb", label: "Design Build MRB" },
    { value: "design_build_bayway", label: "Design Build BAYWAY" },
    { value: "private", label: "Private" },
    // { value: "state", label: "State" },
  ];

  const [displayOptions, setDisplayOptions] = useState(Keysoptions);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchingOptions, setFetchingOptions] = useState(false);

  useEffect(() => {
    if (open) fetchProjectOptions();
  }, [open]);

  const fetchProjectOptions = async () => {
    setFetchingOptions(true);
    try {
      const response = await AxiosInstance.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_GET_PROJECT_TYPE_OPTIONS}`,
      );

      const apiData = response.data?.data;

      // 1. Get both the status and the projects string
      const statusRequest = apiData?.raw_status_request; // "0" or "1"
      const approvedStr = apiData?.approved_projects;

      // 2. LOGIC: If status is "0", show DEFAULT list.
      // If status is "1" (or anything else) AND we have data, show RESTRICTED list.
      if (
        statusRequest !== "0" &&
        approvedStr &&
        approvedStr.trim() !== "" &&
        approvedStr !== "0"
      ) {
        const approvedArray = approvedStr.split(",");

        const filteredMatches = Keysoptions.filter((opt) =>
          approvedArray.includes(opt.value),
        );

        // Show ONLY approved items in dropdown
        setDisplayOptions(filteredMatches);
        // Pre-select those items
        // setSelectedOption(filteredMatches);
      } else {
        // FALLBACK: Status is "0" or no data found -> Show all default options
        setDisplayOptions(Keysoptions);
        setSelectedOption(null);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      toast.error("Failed to load project data");
    } finally {
      setFetchingOptions(false);
    }
  };

  const handleSelectChange = (selected) => setSelectedOption(selected);

  const handleSubmit = async () => {
    if (!selectedOption || selectedOption.length === 0) {
      toast.error("Please select at least one option");
      return;
    }
    setLoading(true);
    try {
      const payload = {
        status_request: "pending",
        request_for: selectedOption.map((item) => item.value),
      };
      await AxiosInstance.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_REQUEST_FOR_PROJECT_UPLOAD}`,
        payload,
      );
      requestApproved("pending");
      toast.success("Request submitted successfully");
      handleClose();
      setSelectedOption(null);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal size="md" show={open} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Upload Project Request</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {fetchingOptions ? (
          <div className="text-center py-4">
            <img src={loaderImg} alt="loading" width="40" />
          </div>
        ) : (
          <div>
            <div className="mb-3">
              <Select
                options={displayOptions}
                value={selectedOption}
                onChange={handleSelectChange}
                placeholder="Select project types..."
                isSearchable
                isMulti
                styles={{
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
              />
            </div>
            <div className="mt-3 text-center">
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}
